import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-account-settings-icon',
  templateUrl: './account-settings-icon.component.html',
  styleUrls: ['./account-settings-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSettingsIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
